class APIBaseResponse {
    constructor($ionicPopup, $ionicLoading, $state, localStorageService) {
        this.$state =  $state;
        this.localStorageService =  localStorageService;
        this.$ionicPopup = $ionicPopup;
        const self = this;
        return {

            /**
             * Base on success method for api calls
             *
             * @param  {Object} response
             * @return {Object} res
             */
            onSuccess: function (response) {
                let res = null;

                if (!angular.isUndefined(response)) {
                    if (typeof (response) === 'object') {
                        res = response.plain();
                    } else {
                        res = response;
                    }
                }

                return res;
            },

            /**
             * Base on success method for blob api calls
             *
             * @param  {Object} response
             * @return {Object} res
             */
            onBlobSuccess: function (response) {
                return response;
            },

            /**
             * Base on error method for api calls
             *
             * @param  {Object} error
             * @return {void}
             */
            onError: function (error) {

                self.handleError(error);

                // remove any existance of spinner in case of error
                $ionicLoading.hide();
            },

            onLoginError(error) {
                if (error) {
                    if (error.status === -1 || error.status === 503) {
                        $ionicPopup.alert({
                            title: '<b>Error</b>',
                            template: '<span focus-button>{{"ERR_SERVER_DOWN" | translate }}</span>',
                            okType: 'button-picton-blue'
                        });
                    } else {
                        self.handleError(error);
                    }
                }
                $ionicLoading.hide();
            }
        };
    }

    handleError(error) {
        if (error && error.data && error.data.message) {
            if (error.data.code === 'ERR_INVALID_TOKEN') {
                this.$state.go('login');
                if (!this.localStorageService.get('notAuthorized')) {
                    this.localStorageService.set('notAuthorized', true);
                    this.localStorageService.remove('token');
                    this.$ionicPopup.alert({
                        title: '<b>Error</b>',
                        template: '<span focus-button>{{"' + error.data.code + '" | translate }}</span>',
                        okType: 'button-picton-blue'
                    });
                }
            } else {
                this.$ionicPopup.alert({
                    title: '<b>Error</b>',
                    template: '<span focus-button>{{"' + error.data.code + '" | translate }}</span>',
                    okType: 'button-picton-blue'
                });
            }
        }
    }
}

export default APIBaseResponse;



/** WEBPACK FOOTER **
 ** ./src/app/services/apiBaseResponse.js
 **/